<div class="loading">
    <img src="/assets/img/logoInvoice.svg" alt="loading">
</div>
